import React from "react";
import logoImage from "@/assets/Digital Health logo 1.png";

export const Logo: React.FC<{ size?: number; className?: string }> = ({ 
  size = 80, 
  className = "" 
}) => (
  <a href="/" className={`flex items-center ${className}`} aria-label="Go to homepage">
    <img
      src={logoImage}
      alt="ChipChip Logo"
      className="hover:scale-105 transition-transform duration-300"
      width={size}
      height={size}
    />
  </a>
); 
